<template>
  <div class="computer">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "home",
  data () {
    return {
      
    }
  },
  mounted () {
    // 判断移动端登录还是pc端登录
    let mobile = navigator.userAgent.match(/(phone|ios|Android)/i)
    let pad =  navigator.userAgent.match(/(pad|pod|iPod|iPad)/i);
    console.log(navigator.userAgent);
    // 判断设备类型 跳转不同端登录页面
    if(mobile) {
      this.$router.push({path:'/mobilelogin'})
    } else if(pad){
      this.$router.push({path:'/ipadindex'})
    } else {
      this.$router.push({path:'/loginindex'})
    }
  }
};
</script>
<style lang="scss" scoped>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.computer{
  width: 100%;
  height: 100vh;
  min-width: 1124px;
  /* // background: #a8ee7c; */
  background: url('~@/assets/images/login/classbg2.png') no-repeat;
  background-size: cover;
  background-position: center 0;
  background-attachment:fixed;
}
@media screen and (max-width: 768px){
  .computer{
    width: 100%!important;
    height: 100%!important;
    background: #fff!important;
    position: fixed;
    top: 0;
    left: 0;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px){
  .computer{
    width: 100%!important;
    height: 100%!important;
    background: #fff!important;
    position: fixed;
    top: 0;
    left: 0;
  }
}

@media screen and (min-width: 1200px){
    .computer{
      width: 100%!important;
      height: 100%!important;
      /* background: #fff!important; */
    }
}
</style>

